import { render, staticRenderFns } from "./UvAnalytics.vue?vue&type=template&id=44c27ac8"
import script from "./UvAnalytics.vue?vue&type=script&lang=js"
export * from "./UvAnalytics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports